import React from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button, colors } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "../CheckBoxComponent";
import DiscountPermissions from "../discount-permissions";
import { useTranslation } from "react-i18next";
const formData = [
  { name: "Automatic_Insert", label: "automatic-entry", visible: true },

  {
    name: "UpdatePurchDate",
    label: "allow-edit-opening-stock-date",
    visible: true,
  },
  {
    name: "UpdatePurchPrice",
    label: "allow-edit-opening-stock-price",
    visible: true,
  },
  {
    name: "purchVatUpdate",
    label: "allow-edit-tax",
    visible: true,
  },
  {
    name: "IS_Delete",
    label: "allow-delete-opening-stock-after-entry",
    visible: true,
  },
  {
    name: "IS_Update",
    label: "allow-correct-stock-after-entry",
    visible: true,
  },
  {
    name: "use_price_without_vat",
    label: "use-price-excluding-tax-purchase-order",
    visible: false,
  },
  {
    name: "Purch_than_Less_Purch_Item",
    label: "allow-price-below-purchase-items",
    visible: false,
  },

  {
    name: "Cust_PurchPrice",
    label: "approve-last-supplier-purchase-price",
    visible: false,
  },
  {
    name: "Hide_Purch_Bill_Price",
    label: "hide-sale-price",
    visible: false,
  },
  {
    name: "Purch_out_goods",
    label: "print-goods-exit-permit-purchase-return",
    visible: false,
  },
 
  { 
    name: "allow_discount", 
    label: "allow-discount", 
    visible: true ,
  },
  {
    name: "inv_post_unlock",
    label: "allow-edit-delete-posted-invoice",
    visible: false,
  },
  {
    name: "NoRepeatItem",
    label: "disable-item-grouping",
    visible: true,
  },
  {
    name: "use_barcode_reader",
    label: "use-barcode-reader",
    visible: true,
  },
];

export default function SafesPermisions(props) {
  const { onChange, object, update, sub } = props;
  const { t } = useTranslation(["forms"]);

  const classes = useStylesAcc();

  return (
    <div className={classes.root}>
      <Accordion expanded={true}>



        <AccordionDetails >
          <Grid item container spacing={1}>
            {formData
              ?.filter((d) => d.visible)
              ?.map((item) => {
                // console.log(object);
                return (
                  <Grid xs={6}>
                    <CheckboxItem
                      value={object[item.name] ?? null}
                      name={item.name}
                      label={t(item.label)}
                      onChange={onChange}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </AccordionDetails>

        <AccordionDetails>
          {" "}
          <Typography>{t("discount-settings")}  
          
            </Typography>{" "}    
             
                   
        </AccordionDetails>

        <AccordionDetails style={{backgroundColor:colors.grey[50]}}>
          { object?.allow_discount ? <DiscountPermissions {...props} />: 
          <Typography variant="h5" style={{textAlign:"center"}}> 
          {/* <br />   */}
          {/* {"\n this settings don't work if past discount allowed attribute doesn't enables"} */}
          {"\n "}{t("enable-discount-first-warning")}

            </Typography> }
        </AccordionDetails>
        <Divider className={classes.divider} />
        <AccordionDetails className={classes.subTitle}>
          {" "}
          <Typography>
            {" "}
            <Button
              variant="contained"
              color="secondary"
              size="large"
              disabled={props.submitting}
              onClick={update}
            >
              {t("save-changes")}
            </Button>
          </Typography>{" "}
        </AccordionDetails>
      </Accordion>
      <Swipeable />
    </div>
  );
}
